import React, { memo } from "react";
import Icon from "../../../assets/icons/Icon";

const Button = ({
  className,
  children,
  btnName = "",
  icon = null,
  type = "",
  isDisabled = false,
  onClick,
  isHidden = false,
  id = "",
}) => {
  return (
    <button
      className={`${className}`}
      type={type}
      disabled={isDisabled}
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
      onClick={onClick}
      hidden={isHidden}
      id={id}
      onFocus={(e) => e.target.blur()}
    >
      {children}
      {icon ? <Icon name={icon} /> : null}
    </button>
  );
};

export default memo(Button);
